import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class OrganizationBlockedOfficers extends AbstractService {
	static endpoint = ENDPOINTS.organizationBlockedOfficers;

	static organizationBlockedOfficersApi = NexusService.organizationBlockedOfficersApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_organization_blocked_officers";

	static getAll(queryParams, getCancelToken) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.organizationBlockedOfficersApi
				.getPaginatedOrganizationBlockedOfficers(queryParams)
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				});
		}
		return this.get({
			endpoint: this.endpoint,
			queryParams,
			getCancelToken,
		});
	}

	static update(queryParams, data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const updateReq = {
				id: data.officerId,
				organizationBlockedOfficerUpdatePayload: {
					Note: data.note,
				},
			};
			return this.organizationBlockedOfficersApi
				.updateOrganizationBlockedOfficer(updateReq)
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				});
		}
		return this.post({
			endpoint: this.endpoint,
			queryParams,
			data,
		});
	}

	static delete(queryParams, data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const deleteReq = {
				id: data.officerId,
				organizationBlockedOfficerDeletePayload: {
					Note: data.note,
				},
			};
			return this.organizationBlockedOfficersApi
				.deleteOrganizationBlockedOfficer(deleteReq)
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				});
		}
		return this.del({
			endpoint: `${this.endpoint}`,
			queryParams,
			data,
		});
	}
}
